module.exports = {
	"details": {
		"mainTitle": "Details",
		"price": "Price:",
		"requestInfo": "Request More Info"
	},
	"sidebar": {
		"requestInfo": "Request More Info",
		"customizeItem": "Request Customization"
	},
	"shipping": {
		"mainTitle": "Shipping & Returns",
		"estimateTitle": "Shipping",
		"returnTitle": "Return Policy",
		"viewMoreTitle": "View More Details",
		"viewAllQuotes": "View all shipping quotes",
		"hasQuote": {
			"href": "#all-shipping",
			"canRequest": "View and request shipping quotes",
			"cannotRequest": "View all shipping quotes"
		},
		"noQuote": {
			"href": "#all-shipping-global",
			"canRequest": "Request a shipping quote",
			"cannotRequest": "View details"
		}
	},
	"dealer": {
		"sinceYear": "1stdibs {type} since {sinceYear}",
		"location": "Located in {location}",
		"contact": "contact",
		"infoExpanded": "Additional Information &#8211;",
		"infoCollapsed": "Additional Information &#43;",
		"carouselHeader": "More from this {type}",
		"offeredBy": "Offered By",
		"callDealerCta": "Call Seller"
	},
	"suggestion": {
		"carouselHeader": "You May Also Like",
		"soldCarouselHeader": "Browse Similar Items",
		"recommendedForYou": "Recommended %s for You"
	},
	"priceStates": {
		"reducedFrom": "Reduced From",
		"onHold": "On Hold",
		"onHoldForUser": "On Hold For You",
		"sold": "Sold",
		"unavailable": "Unavailable",
		"perItem": "per item",
		"uponRequest": "Price Upon Request",
		"soldWithLink": "Sorry, this item from <a href=\"%s\">%s</a> has been sold.",
		"suspended": "Sorry, this item is not currently available.",
		"netPrice": "Net Price",
		"retailPrice": "List Price",
		"off": "Off"
	},
	"linkText": {
		"heroSuspendedPriceLinkText": "Browse %s other %s",
		"viewProfileLinktext": "View Profile"
	},
	"support": {
		"cta": "<span>Questions about your online purchase?</span><br /><span>We're here to help.</span>",
		"linkUrl": "https://support.1stdibs.com/",
		"linkText": "Contact 1stdibs"
	},
	"nydc": {
		"galleryName": "1stdibs Gallery at 200 LEX",
		"streetAddress": "200 Lexington Avenue",
		"cityStateAddress": "New York, NY 10016",
		"urlPath": "/nydc/"
	},
	"print": {
		"print": "Print",
		"printNoPrice": "Print without Price"
	},
	"similar": {
		"header": "Items Similar to",
		"soldHeader": "This <i>{itemTitle}</i> is no longer available.",
		"soldSubheader": "View Similar Items",
		"cta": "View More"
	},
	"productionTime": {
		"title": "Estimated Production Time:"
	},
	"heroTitles": {
		"about": "About",
		"customizationOptions": "Customization Options",
		"aboutTheMaker": "About the Maker"
	},
	"benefits": {
		"title": "Buy Online to Receive Trade Benefits",
		"linkText": "Learn More",
		"linkUrl": "/info/trade/benefits/",
		"fields": [
			{
				"title": "Buyer Protection on every purchase"
			},
			{
				"title": "Lowest advertised net price"
			},
			{
				"title": "Trade Concierge order assistance"
			}
		]
	},
	"guarantee": {
		"title": "Trade Price Guarantee",
		"tooltip": {
			"title": "Trade Price Guarantee",
			"description": "As a trade member, you receive the lowest advertised net price when you purchase through 1stdibs online checkout.",
			"linkText": "Learn More",
			"linkUrl": "/info/trade/net-price-guarantee/"
		}
	},
	"urgency": {
		"title": "In high demand",
		"text": "people are viewing this item"
	}
};


//////////////////
// WEBPACK FOOTER
// ./json/copy/pdp.json
// module id = 1112
// module chunks = 4 14